// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__RGr30","top":"styles_top__18wgI","left":"styles_left__3y3ni","description":"styles_description__3BF2f"};